import { Rule } from '@/Validator/Rules';

export * from './Rules';

export { VuetifyValidateRule } from './VuetifyValidateRule';

export class Validator<T> {
    constructor(validator: Rule<T>, error_message: string) {
        this.validate = validator;
        this.ErrorMessage = error_message;
    }

    static of<T>(validator: Rule<T>, error_message: string) {
        return new Validator<T>(validator, error_message);
    }

    toVuetifyRule() {
        return (v: T) => this.validate(v) || this.ErrorMessage;
    }

    ErrorMessage: string;
    validate: Rule<T>;
}
